export default {
    null2Empty(x)
    {
        return x == null?'':x;
    }
}